import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstErrorMessage',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class FirstErrorMessagePipe implements PipeTransform {
    public transform(errors: unknown): string {
        if (!errors) {
            return null;
        }

        const firstKey = Object.keys(errors)?.[0];
        return errors[firstKey].message || null;
    }
}
